// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3v0Sq","title":"Header_title__1JP6T","side":"Header_side__2mFF-"};